export default [
    {
        path: '/quotations',
        name: 'Company / Quotations',
        component: () => import('@/views/pages/quotations'),
        meta:
        {
            page: 'list',
        },
        children:
        [
            {
                path: 'overview',
                name: 'Company / Quotation Overview',
                component: () => import('@/views/pages/quotations'),
                meta:
                {
                    page: 'overview',
                    subPage: 'main',
                },
            },
            {
                path: ':code',
                name: 'Company / View Quotation',
                component: () => import('@/views/pages/quotations'),
                meta:
                {
                    page: 'view',
                },
            },
        ],
    },
];